import React, { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";

import {
  SPECIAL_CHARACTER,
  AUTO_COMPLETE_SELECT_ENABLE,
  ACCOUNT_SECURITY,
} from "../../../../shared/Constants";
import {
  checkValidity,
  EMAIL_MATCHER_REGEX,
  getTargetUrlDropDownSortedList,
} from "../../../../shared/utility";
import Input from "../../../../UI/Input/Input";
import classes from "./CallerDetails.css";
import ReactTooltip from "react-tooltip";
import Message from "../../../../components/Message/Message";
import * as actions from "../../../../store/actions/index";
import ImpactedMember from "../ImpectedMember/ImpactedMember";

const CallerDetails = (props) => {
  const [errorMsg, setErrorMsg] = useState("");
  const [callerDetailsForm, setCallerDetailsForm] = useState({
    targetPortal: {
      elementType: props.impactedMemberData
        ? "select"
        : AUTO_COMPLETE_SELECT_ENABLE
        ? "autocompleteselectdefault"
        : "select",
      elementConfig: {
        type: "text",
        id: "targetPortal",
        placeholder: "Select One",
        options: [],
        cssProperties: {
          width: "140%",
          left: "-20%",
        },
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
      disabled: props.formType === "details",
      touched: false,
      label: "Target Portal",
      inputType: "ExtendedInput",
    },
    firstName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "firstName",
        placeholder: "first name",
      },
      value: "",
      validation: {
        required: true,
        minlength: 2,
        maxlength: 40,
        specialchar: SPECIAL_CHARACTER,
      },
      valid: false,
      touched: false,
      position: "left",
      label: "First Name",
      inputType: "Half",
    },
    lastName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "lastName",
        placeholder: "last name",
      },
      value: "",
      validation: {
        required: true,
        minlength: 2,
        maxlength: 40,
        specialchar: SPECIAL_CHARACTER,
      },
      valid: false,
      touched: false,
      position: "right",
      label: "Last Name",
      inputType: "Half",
    },
    email: {
      elementType: "input",
      elementConfig: {
        type: "email",
        id: "preferred_email",
        pattern: EMAIL_MATCHER_REGEX,
        placeholder: "abc.xyz@email.com",
        title: "Format: abc.xyz@email.com",
      },
      value: "",
      validation: {
        required: false,
        minlength: 7,
        maxlength: 255,
        pattern: EMAIL_MATCHER_REGEX,
      },
      disabled: false,
      valid: false,
      position: "right",
      touched: false,
      label: "Preferred Email",
      inputType: "Half",
    },
    countryCode: {
      elementType: "inputPhoneCode",
      elementConfig: {
        type: 'text',
        id: 'countryCode',
        minLength: 1,
        maxLength: 3,
        pattern: '[0-9]{1,3}',
        title:'Country Code can only contain numbers',
      },
      value: "",
      validation: {
        required: true,
        minlength: 1,
        maxlength: 3
      },
      disabled: false,
      valid: false,
      // position: "left",
      touched: false,
      label: "Country Code",
      inputType: "PhoneCodeSN",
    },
    phone: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "phone",
        minLength: 10,
        maxLength: 10,
        pattern: "[0-9]{1,10}",
        title: "Phone Numbers can only contain numbers",
      },
      value: "",
      validation: {
        required: true,
        minlength: 10,
        maxlength: 10,
      },
      disabled: false,
      valid: false,
      position: "left",
      touched: false,
      label: "Member's Call Back Number",
      inputType: "phoneInput30",
    },
    username: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "userName",
        placeholder: "Username",
      },
      value: "",
      validation: {
        required: false,
        minlength: 2,
        maxlength: 40,
        specialchar: SPECIAL_CHARACTER,
      },
      valid: false,
      touched: false,
      position: "left",
      label: "Username",
      inputType: "Half",
    },
    memberId: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "memberId",
        placeholder: "MemberId",
      },
      value: "",
      validation: {
        required: false,
        minlength: 2,
        maxlength: 40,
        specialchar: SPECIAL_CHARACTER,
      },
      valid: false,
      touched: false,
      position: "left",
      label: "Member ID",
      inputType: "Half",
    },
    ssn: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "ssn",
        placeholder: "SSN",
        // minLength: 6,
        maxLength: 9,
        pattern: "[0-9]{1,10}",
        title: "SSN can only contain numbers",
      },
      value: "",
      validation: {
        required: false,
        // minlength: 6,
        maxlength: 9,
        allowEmpty: true,
        // specialchar: SPECIAL_CHARACTER,
      },
      valid: false,
      touched: false,
      position: "left",
      label: "Social Security Number",
      inputType: "Half",
    },
  });

  useEffect(() => {
    if (!props.portalsList || !props.portalsList.length > 0) {
      props.fetchPortals(props.sdkPortalList);
    }
  }, []);

  useEffect(() => {
    if (
      !callerDetailsForm.targetPortal.elementConfig.options.length &&
      props.portalsList !== null
    ) {
      let updatedForm = { ...callerDetailsForm };
      const porLst = getTargetUrlDropDownSortedList(
        props.portalsList,
        ACCOUNT_SECURITY,
        props.disabledPortals,
        props.user.userType
      );
      if (props.impactedMemberData) {
        const lst = porLst.filter(
          (portal) => portal.value === props.impactedMemberData.prtlShrtNm
        );
        updatedForm.targetPortal.value = lst[0]?.value;
      }
      updatedForm.targetPortal.elementConfig.options = porLst;
      setCallerDetailsForm(updatedForm);
      props.setCallerDetails(updatedForm);
    }
    // if (
    //   props.impactedMemberData ||
    //   (props.incidentMembersList && props.incidentMembersList.length > 0)
    // ) {
      const essoData =
        (props.incidentMembersList && props.incidentMembersList[0]?.essoData) ||
        {};
        const memberData =
        (props.incidentMembersList && props.incidentMembersList[0]?.member && props.incidentMembersList[0]?.member[0]) ||
        {};
      const form = { ...callerDetailsForm };
      form.email.value =
        props.impactedMemberData?.callerEmail || essoData.email?.value || "";
      form.firstName.value =
        props.impactedMemberData?.callerFirstName || essoData.firstName || "";
      form.firstName.disabled = (props.impactedMemberData?.callerFirstName || essoData.firstName) ? true : false;
      form.lastName.value =
        props.impactedMemberData?.callerLastName || essoData.lastName || "";
      form.lastName.disabled = (props.impactedMemberData?.callerLastName || essoData.lastName) ? true : false;
      form.phone.value =
        props.impactedMemberData?.callerPhone || essoData.phone?.number || "";
      form.countryCode.value =
        props.impactedMemberData?.callerPhone || essoData.phone?.countryCode || "";
      form.username.value =
        props.impactedMemberData?.username || essoData.userName || "";
      form.username.disabled = (props.impactedMemberData?.username || essoData.userName) ? true : false;
      form.memberId.value =
        props.impactedMemberData?.memberId || memberData.mdmSubscriberId || "";
      form.memberId.disabled = (props.impactedMemberData?.memberId || memberData.mdmSubscriberId) ? true : false;
      setCallerDetailsForm(form);
      props.setCallerDetails(form);
    // }
  }, [props.impactedMemberData, props.incidentMembersList, props.portalsList]);

  useEffect(() => {
    if (
      callerDetailsForm.firstName.valid &&
      callerDetailsForm.lastName.valid &&
      callerDetailsForm.phone.valid &&
      callerDetailsForm.email.valid
    ) {
      props.isValid(true);
    } else {
      props.isValid(false);
    }
  }, [callerDetailsForm]);

  useEffect(() => {
    const updatedForm = {};
    Object.keys(callerDetailsForm).map((key) => {
      const formCopy = { ...callerDetailsForm[key] };
      formCopy.disabled = props.formDisabled;
      updatedForm[key] = formCopy;
    });
    setCallerDetailsForm(updatedForm);
  }, [props.formDisabled]);

  useEffect(()=>{
    let updatedForm = { ...callerDetailsForm };
    Object.keys(callerDetailsForm).map((key) => {
      const formCopy = { ...callerDetailsForm[key] };
      formCopy.disabled = false
      updatedForm[key] = formCopy;
    });
    updatedForm['targetPortal'].value = null;
    updatedForm['targetPortal'].valid = false;
    updatedForm['ssn'].value = '';
    setCallerDetailsForm(updatedForm);
    props.setCallerDetails(updatedForm);
  },[props.resetValues])

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...callerDetailsForm };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
      setErrorMsg({ message: validation.message });
    } else {
      if(updatedFormElement.validation.allowEmpty) {
        updatedFormElement.valid = true;
      } else {
        updatedFormElement.valid = false;
      }
    }
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setCallerDetailsForm(updatedForm);
    props.setCallerDetails(updatedForm);
  };

  const callerForm = (
    <div className={classes.formLayout}>
      {Object.keys(callerDetailsForm).map((key) => (
        <Input
          key={key}
          elementType={callerDetailsForm[key].elementType}
          elementConfig={callerDetailsForm[key].elementConfig}
          value={callerDetailsForm[key].value}
          invalid={!callerDetailsForm[key].valid}
          shouldValidate={callerDetailsForm[key].validation}
          touched={callerDetailsForm[key].touched}
          disabled={callerDetailsForm[key].disabled}
          required={callerDetailsForm[key].validation?.required}
          label={callerDetailsForm[key].label}
          changed={(event) => inputChangedHandler(event, key)}
          inputType={callerDetailsForm[key].inputType}
        />
      ))}
    </div>
  );

  return (
    <>
      <div className={classes.FormTitle}>
        {"Member Details"}
        &nbsp;
        <a data-tip data-for="callerDetails">
          <span className="fa fa-question-circle"></span>{" "}
        </a>
        <ReactTooltip id="callerDetails">
          <span>Provide the details of the caller</span>
        </ReactTooltip>
      </div>
      <div className={classes.box}>
        <Message msgType="Error" info={errorMsg} />
        {callerForm}
        <ImpactedMember
          isSameSection
          setButtonState={props.isSaveButtonDisabled}
          userType={props.userType}
          formDisabled={props.formDisabled}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
    incidentMembersList: state.member?.incidentMembersList,
    portalsList: state.personalInfo?.portals,
    user: state.usr.user,
    formType: state.serviceNow.formType,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchPortals: (sdkPortalList) =>
      dispatch(actions.fetchMemberAccountPortals(sdkPortalList)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallerDetails);
